import { render, staticRenderFns } from "./ViewPropertyStatus.vue?vue&type=template&id=6bf06ef2&scoped=true"
import script from "./ViewPropertyStatus.vue?vue&type=script&lang=js"
export * from "./ViewPropertyStatus.vue?vue&type=script&lang=js"
import style0 from "./ViewPropertyStatus.vue?vue&type=style&index=0&id=6bf06ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf06ef2",
  null
  
)

export default component.exports